import * as routes from "./routes";
import * as theme from "./theme";
import * as appHistory from "./history";

const { lightTheme, darkTheme } = theme;
const { menuItems, paths } = routes;
const { history } = appHistory;
export { lightTheme, darkTheme, menuItems, paths, history, routes };
export default { age: 40 };
